import type {RefObject} from 'react';
import type {InputFieldState} from '@Components/input-field-v2/input-field.types';
import type {ControlledListItemType2Props} from "@Components/controlled-list/components/controlled-list-item-type-2";

export interface TagsInputFieldProps {
  allSelectedTags: string[];
  allSuggestedTags: string[];
  onInputChangeCallback: (input: string, tagInputCompletedRef: RefObject<boolean | null>) => void;
  inputClassName: string;
  onSaveTagCallback: (tag: string) => void;
  onPillClick: (pillText: string) => void;
  onRemoveTag: () => void;
  inputPlaceholder: string;
  doAutofocusOnBlur?: boolean;
  inputFieldState?: InputFieldState;
  informationText?: string;
  dropdownClassName?: string;
  shouldFlip?: boolean;
  wrapperClassName?: string;
  tagsLimit?: number;
  suggestionPillClassName?: string;
  suggestionPillIsBoldText?: boolean;
  inputContainerClassName?: string;
  showPreviewTags?: boolean;
  previewTagsDetail?: ControlledListItemType2Props[];
  retainInputOnError?: boolean;
  tagInputType?: TagInputType;
  inputFieldClassName?: string;
  inputFieldContainerClassName?: string;
  shouldHideDropdownWhenEmpty?: boolean;
  doAutofocusOnMount?: boolean;
  suggestionsPopoverRef?: RefObject<HTMLDivElement | null>;
  doAutofocusOnSubmit?: boolean;
  maxTagLength?: number;
}

export enum TagInputType {
  EMAIL = 'email',
  TEXT = 'text',
}
